// imports
import { ReactNode } from 'react'

// utils

// components

// styles
import './ContentCenter.scss'

type Props = {
    children: ReactNode
}

const ContentCenter = ({ children }: Props) => {
    return <div className="content-center">{children}</div>
}

export default ContentCenter
